import { render } from "./ArchiveModal.vue?vue&type=template&id=71ba55dd"
import script from "./ArchiveModal.vue?vue&type=script&lang=js"
export * from "./ArchiveModal.vue?vue&type=script&lang=js"

import "./ArchiveModal.vue?vue&type=style&index=0&id=71ba55dd&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__